module.exports = "<div class=\"\">\n  <div class=\"section row\"\n    ng-hide=\"disableRadioButtons\">\n    <my-radio-button ng-repeat=\"radio in railwayRadios\"\n      class=\"col s4\"\n      my-label=\"radio.label\"\n      my-id=\"radio.id\"\n      ng-model=\"myWagon.railwayIdNull\"\n      my-value=\"radio.value\">\n    </my-radio-button>\n  </div>\n\n  <my-select-railway ng-show=\"myWagon.railwayIdNull === 'full'\"\n    my-railway=\"myRailway\"\n    my-area=\"myArea\">\n  </my-select-railway>\n</div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./public/javascript/sygem/entities/trains/wagon/directives/search/myWagonRailwaySearch.html
// module id = 1129
// module chunks = 0